import React, { useContext, useState } from 'react';
import './styles.scss'
import Menu from '../../Components/Menu';
import Navbar from '../../Components/Navbar';
import { BankOutlined, FormOutlined, LineChartOutlined } from '@ant-design/icons';
import BodyContent from '../../Components/BodyContent';
import { StylesContext } from '../../Contexts/UserContext/StylesContext';
import Filters from '../../Components/Filters';
import { DashboardBox } from '../../Components/Filters-Boxs/DashboardBox';
import { MenuBox } from '../../Components/Filters-Boxs/MenuBox';
import { VariablesContext } from '../../Contexts/UserContext/VariablesContext';
import DepositExtractionForm from '../../Components/Forms/DepositExtractionForm';
import { useForm } from 'antd/es/form/Form';
import TransfersBetweenAccounts from '../../Components/Forms/TransfersBetweenAccounts';
import TransfersBetweenBoxes from '../../Components/Forms/TransfersBetweenCheckouts';
import TransfersSuppliers from '../../Components/Forms/TransfersSuppliers';
import { UserContext } from '../../Contexts/UserContext/UsersContext';
import FundsMovementForm from '../../Components/Forms/FundsMovementForm';
import PucrchaseSaleCurrencyForm from '../../Components/Forms/PucrchaseSaleCurrenciesForm';
import CurrentAccountComission from '../../Components/Forms/CurrentAccountComission';
import { ExchangeAndTrasnfers } from '../../Components/Forms/ExchangeAndTransfers';
import { CurrencyAveragesBox } from '../../Components/Filters-Boxs/CurrencyAveragesBox';


export const Dashboard: React.FC =()=>{

  const {dashboard_body} = useContext(StylesContext)
  const {initializationMode} = useContext(UserContext)
  const {setShowForms, showForms} = useContext(VariablesContext)
  const [ form_deposit_extraction ] = useForm()
  const [ form_transferers ] = useForm()
  const [ form_buy_and_sell ] = useForm()
  const [ form_funds_movements ] = useForm()
  const [ form_current_account_commission ] = useForm()
  const [ form_exchange_trasnferer ] = useForm()
  const [ menuBalances, setMenuBalances]= useState(false)
  const [ menuForms, setMenuForms]= useState(false)
  const [ menuAverages, setMenuAverages]= useState(false)

  return(
    <div className="dashboard_container">   
     
      { showForms.deposit_extraction && 
        <DepositExtractionForm
          form={form_deposit_extraction}
        />
      }
      { showForms.transferer && 
        <TransfersBetweenAccounts
          form={form_transferers}
        />
      }    
      { showForms.transfer_to_suppliers && 
        <TransfersSuppliers
          form={form_transferers}
        />
      } 
      { showForms.buy_and_sell && 
        <PucrchaseSaleCurrencyForm
          form_buy_and_sell={form_buy_and_sell}
        />
      } 
      { showForms.transfers_between_cashs && 
        <TransfersBetweenBoxes
          form={form_transferers}
        />
      }  
      { showForms.funds_movements && 
        <FundsMovementForm        
          form={form_funds_movements}
        />
      }  
      { showForms.current_account_commission && 
        <CurrentAccountComission       
          form={form_current_account_commission}
        />
      }    
      {
        showForms.exchange_trasnfer &&
        <ExchangeAndTrasnfers
          form={form_exchange_trasnferer}
        />
      }
      <Filters
        components={<DashboardBox/>}
        height={0}
        tooltip='Saldos de Cajas'
        icon={<BankOutlined />}
        collapsedFilsters={menuBalances}
        setCollapsedFilters={setMenuBalances}
        marginTop={0}
        widhtSections={820}
      />
      {
        !initializationMode &&
          <Filters
            components={
              <MenuBox
                setShowForms={setShowForms}
              />
            }
            height={60}
            marginTop={60}
            tooltip='Formularios'
            icon={<FormOutlined />}
            collapsedFilsters={menuForms}
            setCollapsedFilters={setMenuForms}
          />
      }
      <Filters
        components={<CurrencyAveragesBox />}
        height={120}
        marginTop={120}
        tooltip='Promedios del Día'
        icon={<LineChartOutlined />}
        collapsedFilsters={menuAverages}
        setCollapsedFilters={setMenuAverages}
        widhtSections={700}
      />
          
      <Navbar/>    
      <div className='dashboard_body'
        style={{
          height: `${dashboard_body}px`
        }}
      >
        <Menu/>              
        <BodyContent/>
      </div>       
    </div>
  )
}